/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type WorkflowComparisonTypeEnum = 'UNDEFINED' | 'BOOLEAN' | 'NUMBER' | 'DATE' | 'LIST' | 'STRING' | 'DOUBLE_LIST' | 'DATE_TIME';

export const WorkflowComparisonTypeEnum = {
    UNDEFINED: 'UNDEFINED' as WorkflowComparisonTypeEnum,
    BOOLEAN: 'BOOLEAN' as WorkflowComparisonTypeEnum,
    NUMBER: 'NUMBER' as WorkflowComparisonTypeEnum,
    DATE: 'DATE' as WorkflowComparisonTypeEnum,
    LIST: 'LIST' as WorkflowComparisonTypeEnum,
    STRING: 'STRING' as WorkflowComparisonTypeEnum,
    DOUBLE_LIST: 'DOUBLE_LIST' as WorkflowComparisonTypeEnum,
    DATE_TIME: 'DATE_TIME' as WorkflowComparisonTypeEnum
};

